module.exports = __webpack_public_path__ + "static/media/new_rieltor_bonus_desktop_x2.f23848f0.png";